import type { SxProps, Theme } from '@mui/material';

export const BANNER_HEIGHT = { xs: 140, sm: 180 };

export const bannerIconButtonSx: SxProps<Theme> = {
  color: 'text.secondary',
  transition: 'all 0.15s ease',
  '&:hover': { bgcolor: 'action.hover' },
};
